import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c01c999c")
const _hoisted_1 = { class: "inner" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['dropdown-wrapper', { 'is-authenticated': _ctx.isAuth }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        (_ctx.isAuth)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "link-my-account",
                  href: _ctx.fullPath('my-account/edit-account/')
                }, _toDisplayString(_ctx.$t("account_menu.my_account")), 9, _hoisted_2)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "link-orders",
                  href: _ctx.fullPath('my-account/orders')
                }, _toDisplayString(_ctx.$t("account_menu.my_orders")), 9, _hoisted_3)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "link-subscriptions",
                  href: _ctx.fullPath('my-account/subscriptions/')
                }, _toDisplayString(_ctx.$t("account_menu.my_subscriptions")), 9, _hoisted_4)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "link-faq",
                  href: _ctx.fullPath('frequently-asked-questions')
                }, _toDisplayString(_ctx.$t("account_menu.faq")), 9, _hoisted_5)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "log-out link-logout",
                  href: _ctx.getLogOutLinkPath(`wp-login.php?action=logout`)
                }, _toDisplayString(_ctx.$t("buttons.log_out")), 9, _hoisted_6)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "link-register",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLinkClick && _ctx.handleLinkClick(...args))),
                  href: _ctx.fullPath(`sign-in/?action=register`)
                }, _toDisplayString(_ctx.$t("buttons.create_account")), 9, _hoisted_7)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "link-sign-in",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLinkClick && _ctx.handleLinkClick(...args))),
                  href: _ctx.getSignInLinkPath(`sign-in/`)
                }, _toDisplayString(_ctx.$t("buttons.sign_in")), 9, _hoisted_8)
              ])
            ], 64))
      ])
    ])
  ], 2))
}